import { combineReducers } from 'redux';
import received from '../screens/Received/reducers';
import sended from '../screens/Sended/reducers';
export default combineReducers({
  received,
  sended,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/StickyNotes/reducers/index.js
 **/